import React from 'react'
import { connect } from 'react-redux'
import SupplierDiv from 'tyan/menus/SupplierManagerPage/SupplierDiv'
import { addListItem, changeListItem, deleteListItem, getListIds, getListFromValues, hasChangedValues, getFormValue, getListItems, getMergedValues, changeItemsValue } from '../../../public/utility'
import { exportFile } from 'tyan/public/index'
class SupplierEvaluateDiv extends React.Component {

    // constructor() {
    //     super()
    //     window.form = this
    // }
    state = {}
    componentDidMount = () => {
        const { id } = this.props
        this.handlerInitValue(id)
    }

    handlerInitValue = (id) => {
        const { taskName } = this.props
        Tyan.doPostEvent({
            event: 'GetSupplierEvaluate',
            data: { id, taskName },
            onEnd: ({ errorMessage, initValues基本信息, 状态名称, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, 状态名称, initValues基本信息, changedValues基本信息: {}, optionsParas })
            }
        })
    }

    handlerGetSupplier = () => {
        const supplierName = getFormValue(this, '基本信息', '供应商名称')
        Tyan.doPostEvent({
            event: 'GetSupplierNameInfo',
            data: { supplierName },
            onEnd: ({ errorMessage, SupplierID }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Tyan.pubForm.showDialog('供应商基本信息', props => <SupplierDiv {...props} id={SupplierID} auditShow={false} />)

            }
        })

    }

    handlerSave = () => {
        const { id, changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveSupplierEvaluate',
            data: {
                id, changedValues基本信息
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                this.handlerInitValue(id)
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerSupplierEvalyateExport = () => {
        const { id } = this.state
        exportFile(null, null, "SupplierEvaluateExport?id=" + id)
    }

    fieldset基本信息 = () => {
        const { 状态名称, bReadOnly } = this.state
        const { list } = getListItems(this, '基本信息', '评价项')
        var field = []
        field.push({ _text: '评价编号', minWidth: '95%', disabled: true })
        field.push({ _date: '创建日期', minWidth: '95%', disabled: true })
        field.push({ _text: '评价项目名称', minWidth: '95%', disabled: true })
        //field.push({ _text: '供应商名称', minWidth: '95%', disabled: false, })
        field.push({
            _text: '供应商名称', name: '供应商名称', disabled: true, minWidth: '200px', button: {
                text: '查看',
                handler: () => this.handlerGetSupplier(),
            },
        })

        field.push({ _text: '申请原因', minWidth: '95%', maxRows: 3, disabled: true })
        // field.push({ _text: '采购项目', minWidth: '95%', disabled: true })
        field.push({ _files: '附件', minWidth: '95%', disabled: 状态名称 != '申请中' || bReadOnly})
        const bShow = (状态名称 == '意见填写' || 状态名称 == '已完成')
        if (bShow)
            field.push({ _text: '实验室主任意见', minWidth: '95%', maxRows: 3, disabled: 状态名称 !== '意见填写' })

        const p = { margin: '5px 15px 5px 15px', minWidth: 150, _full: true, flex: 1 }
        list.forEach(o => {
            var items = []
            items.push({
                _group: '', margin: '0 10 0 0', minWidth: '90%', items: [
                    { _text: '名称', ...p, minWidth: bShow ? '80%' : '45%', disabled: true },
                    { _select: '审核人', minWidth: '45%', required: true, disabled: 状态名称 !== '申请中' },
                    { _int: '总分', ...p, minWidth: '15%', disabled: true, cdt: () => bShow, labelMinWidth: '2em' },
                    { _label: '评价内容', ...p, minWidth: '35%' },
                    { _label: '考核标准及分值', ...p, minWidth: '45%' },
                    { _label: '得分', ...p, minWidth: '15%' },
                ]
            })
            const { list: contentList } = getListItems(this, '基本信息', `评价项[${o.id}].内容`)
            contentList.map(cn =>
                items.push({
                    _group: '', margin: '0 10 0 0', list: { listName: '内容', id: cn.id }, minWidth: '90%', items: [
                        { _text: '', name: '评价内容', disabled: true, ...p, minWidth: '35%', tooltip: cn.评价内容 },
                        { _text: '', name: '考核标准及分值', disabled: true, ...p, minWidth: '45%', tooltip: cn.考核标准及分值 },
                        { _int: '', name: '得分', ...p, textAlign: 'left', disabled: 状态名称 !== '评分中', minWidth: '15%' },
                    ]
                }))
            const list1 = { listName: '评价项', id: o.id }
            field.push({ _border: '', margin: '0 0 15 0', list: list1, minWidth: '90%', items })
        })
        field.push({ _int: '总分', minWidth: '95%', disabled: true })
        if (bShow)
            field.push({ _text: '评定等级', minWidth: '95%', })
        return field
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly } = this.props
        const { errorMessage, initValues基本信息, 状态名称} = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth='1400'
            controls={
                bReadOnly ?
                    [
                        { _button: '打印', icon: 'print', handler: this.handlerSupplierEvalyateExport, disabled: this.bChanged(), cdt:()=> 状态名称 == '已完成'},
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _flow: 'SupplierEvaluateApplyFlow', disabled: bChanged },
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !bChanged },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly, },
                    {
                        _fieldsets: [
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                        ], docked: 'right', width: '50%',
                    }
                ]}
        />
    }
}

export default connect()(SupplierEvaluateDiv)